import { genderOptions } from '@/app/listings/constants'

export interface BreadcrumbItem {
  label: string
  href?: string
  isCurrentPage?: boolean
  isCategory?: boolean
}

interface Category {
  id: string
  name: string
}

export const createListingBreadcrumbs = (
  sexI18n?: string | null,
  categories?: Category[] | null
): BreadcrumbItem[] => {
  const items: BreadcrumbItem[] = []

  if (sexI18n) {
    const genderOption = genderOptions.find(
      (option) => option.label === sexI18n
    )
    const genderId = genderOption?.id || '0'

    items.push({
      label: sexI18n,
      href: `/listings?gender=${genderId}`,
    })
  }

  if (categories && categories.length > 0) {
    categories.forEach((category, index) => {
      const categoryItem: BreadcrumbItem = {
        label: category.name,
        isCurrentPage: index === categories.length - 1,
        isCategory: true,
      }

      if (sexI18n) {
        const genderOption = genderOptions.find(
          (option) => option.label === sexI18n
        )
        const genderId = genderOption?.id || '0'
        categoryItem.href = `/listings?gender=${genderId}&categories=${category.id}`
      } else {
        categoryItem.href = `/listings?categories=${category.id}`
      }

      items.push(categoryItem)
    })
  } else if (sexI18n && items.length > 0) {
    items[items.length - 1].isCurrentPage = true
  }

  return items
}
